module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-dialog', {
    attrs: {
      "value": _vm.value,
      "max-width": "600px"
    },
    on: {
      "input": function($event) {
        return _vm.$emit('input')
      }
    }
  }, [_c('v-card', [_c('v-toolbar', {
    staticClass: "elevation-2",
    attrs: {
      "dense": ""
    }
  }, [_c('v-spacer'), _vm._v(" "), _c('v-toolbar-title', [_vm._v("\n        Create New User\n      ")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        return _vm.close()
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-select', {
    attrs: {
      "filled": "",
      "items": _vm.userType_options,
      "label": "Select User Type",
      "item-value": "value",
      "item-text": "text"
    },
    model: {
      value: (_vm.user.role),
      callback: function($$v) {
        _vm.$set(_vm.user, "role", $$v)
      },
      expression: "user.role"
    }
  })], 1)], 1), _vm._v(" "), (_vm.user.role !== '') ? _c('v-row', [(_vm.needCompany) ? _c('v-col', {
    attrs: {
      "md": "6",
      "xs": "12"
    }
  }, [_c('label', [_vm._v("Company")]), _vm._v(" "), _c('v-select', {
    attrs: {
      "solo": "",
      "items": _vm.company_options,
      "label": "Assign User to a Company",
      "item-value": "id",
      "item-text": "name"
    },
    model: {
      value: (_vm.user.companyID),
      callback: function($$v) {
        _vm.$set(_vm.user, "companyID", $$v)
      },
      expression: "user.companyID"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('v-col', {
    class: {
      'has-error': _vm.$v.user.firstName.$error
    },
    attrs: {
      "md": "6",
      "sm": "12"
    }
  }, [_c('label', [_vm._v("First Name")]), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "solo": "",
      "placeholder": "Enter user first name"
    },
    on: {
      "input": function($event) {
        return _vm.$v.user.firstName.$touch()
      }
    },
    model: {
      value: (_vm.user.firstName),
      callback: function($$v) {
        _vm.$set(_vm.user, "firstName", $$v)
      },
      expression: "user.firstName"
    }
  }), _vm._v(" "), (!_vm.$v.user.firstName.required && _vm.$v.user.firstName.$error) ? _c('span', {
    staticClass: "help-block"
  }, [_vm._v("First name is required")]) : _vm._e()], 1), _vm._v(" "), _c('v-col', {
    class: {
      'has-error': _vm.$v.user.lastName.$error
    },
    attrs: {
      "md": "6",
      "sm": "12"
    }
  }, [_c('label', [_vm._v("Last Name")]), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "solo": "",
      "placeholder": "Enter user last name"
    },
    on: {
      "input": function($event) {
        return _vm.$v.user.lastName.$touch()
      }
    },
    model: {
      value: (_vm.user.lastName),
      callback: function($$v) {
        _vm.$set(_vm.user, "lastName", $$v)
      },
      expression: "user.lastName"
    }
  }), _vm._v(" "), (!_vm.$v.user.lastName.required && _vm.$v.user.lastName.$error) ? _c('span', {
    staticClass: "help-block"
  }, [_vm._v("\n            Last name is required\n          ")]) : _vm._e()], 1), _vm._v(" "), _c('v-col', {
    class: {
      'has-error': _vm.$v.user.email.$error
    },
    attrs: {
      "md": "6",
      "xs": "12"
    }
  }, [_c('label', [_vm._v("Email")]), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "solo": "",
      "placeholder": "Enter email"
    },
    on: {
      "input": function($event) {
        return _vm.$v.user.email.$touch()
      },
      "keydown": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "space", 32, $event.key, [" ", "Spacebar"])) { return null; }
        $event.preventDefault();
      },
      "paste": _vm.preventPasteSpaces
    },
    model: {
      value: (_vm.user.email),
      callback: function($$v) {
        _vm.$set(_vm.user, "email", $$v)
      },
      expression: "user.email"
    }
  }), _vm._v(" "), (!_vm.$v.user.email.required && _vm.$v.user.email.$error) ? _c('span', {
    staticClass: "help-block"
  }, [_vm._v("\n            Email is required\n          ")]) : _vm._e()], 1), _vm._v(" "), _c('v-col', {
    class: {
      'has-error': _vm.$v.user.password.$error
    },
    attrs: {
      "md": "6",
      "xs": "12"
    }
  }, [_c('label', [_vm._v("Password")]), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "solo": "",
      "type": "password",
      "placeholder": "Enter password"
    },
    on: {
      "blur": function($event) {
        return _vm.$v.user.password.$touch()
      }
    },
    model: {
      value: (_vm.user.password),
      callback: function($$v) {
        _vm.$set(_vm.user, "password", $$v)
      },
      expression: "user.password"
    }
  }), _vm._v(" "), (!_vm.$v.user.password.required && _vm.$v.user.password.$error) ? _c('span', {
    staticClass: "help-block"
  }, [_vm._v("\n            Password is required\n          ")]) : _vm._e()], 1), _vm._v(" "), (_vm.isInf) ? _c('v-col', {
    attrs: {
      "md": "6",
      "xs": "12"
    }
  }, [_c('v-select', {
    attrs: {
      "filled": "",
      "items": _vm.platforms,
      "label": "Select User Type",
      "item-value": "value",
      "item-text": "text"
    },
    model: {
      value: (_vm.platform),
      callback: function($$v) {
        _vm.platform = $$v
      },
      expression: "platform"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.user.role === _vm.userRoles.ACCOUNT_MANAGER) ? _c('v-col', {
    attrs: {
      "md": "6",
      "xs": "12"
    }
  }, [_c('label', [_vm._v("Account Admins")]), _vm._v(" "), _c('v-select', {
    attrs: {
      "solo": "",
      "multiple": "",
      "items": _vm.accountAdmins,
      "label": "Select Admin Users",
      "item-value": "id",
      "item-text": "name"
    },
    model: {
      value: (_vm.user.accountAdmins),
      callback: function($$v) {
        _vm.$set(_vm.user, "accountAdmins", $$v)
      },
      expression: "user.accountAdmins"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.isFacebookPlatform) ? _c('v-col', {
    attrs: {
      "md": "6",
      "xs": "12"
    }
  }, [_c('v-text-field', {
    attrs: {
      "solo": "",
      "placeholder": "Enter Facebook Handle"
    },
    model: {
      value: (_vm.facebook.fbHandle),
      callback: function($$v) {
        _vm.$set(_vm.facebook, "fbHandle", $$v)
      },
      expression: "facebook.fbHandle"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.isFacebookPlatform) ? _c('v-col', {
    attrs: {
      "md": "6",
      "xs": "12"
    }
  }, [_c('v-text-field', {
    attrs: {
      "type": "number",
      "solo": "",
      "placeholder": "Enter Total Followers"
    },
    model: {
      value: (_vm.facebook.totalFollowers),
      callback: function($$v) {
        _vm.$set(_vm.facebook, "totalFollowers", $$v)
      },
      expression: "facebook.totalFollowers"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.isFacebookPlatform) ? _c('v-col', {
    attrs: {
      "md": "6",
      "xs": "12"
    }
  }, [_c('v-text-field', {
    attrs: {
      "type": "number",
      "solo": "",
      "placeholder": "Enter Total Following"
    },
    model: {
      value: (_vm.facebook.totalFollowing),
      callback: function($$v) {
        _vm.$set(_vm.facebook, "totalFollowing", $$v)
      },
      expression: "facebook.totalFollowing"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.isXHSPlatform) ? _c('v-col', {
    attrs: {
      "md": "6",
      "xs": "12"
    }
  }, [_c('v-text-field', {
    attrs: {
      "solo": "",
      "placeholder": "Enter XHS Fullname"
    },
    model: {
      value: (_vm.xhs.xhsFullname),
      callback: function($$v) {
        _vm.$set(_vm.xhs, "xhsFullname", $$v)
      },
      expression: "xhs.xhsFullname"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.isXHSPlatform) ? _c('v-col', {
    attrs: {
      "md": "6",
      "xs": "12"
    }
  }, [_c('v-text-field', {
    attrs: {
      "solo": "",
      "placeholder": "Enter XHS Handle"
    },
    model: {
      value: (_vm.xhs.xhsHandle),
      callback: function($$v) {
        _vm.$set(_vm.xhs, "xhsHandle", $$v)
      },
      expression: "xhs.xhsHandle"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.isXHSPlatform) ? _c('v-col', {
    attrs: {
      "md": "6",
      "xs": "12"
    }
  }, [_c('v-text-field', {
    attrs: {
      "solo": "",
      "placeholder": "Enter XHS ID"
    },
    model: {
      value: (_vm.xhs.xhsID),
      callback: function($$v) {
        _vm.$set(_vm.xhs, "xhsID", $$v)
      },
      expression: "xhs.xhsID"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.isXHSPlatform) ? _c('v-col', {
    attrs: {
      "md": "6",
      "xs": "12"
    }
  }, [_c('v-text-field', {
    attrs: {
      "type": "number",
      "solo": "",
      "placeholder": "Enter Total Followers"
    },
    model: {
      value: (_vm.xhs.totalFollowers),
      callback: function($$v) {
        _vm.$set(_vm.xhs, "totalFollowers", $$v)
      },
      expression: "xhs.totalFollowers"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.isXHSPlatform) ? _c('v-col', {
    attrs: {
      "md": "6",
      "xs": "12"
    }
  }, [_c('v-text-field', {
    attrs: {
      "type": "number",
      "solo": "",
      "placeholder": "Enter Total Following"
    },
    model: {
      value: (_vm.xhs.totalFollowing),
      callback: function($$v) {
        _vm.$set(_vm.xhs, "totalFollowing", $$v)
      },
      expression: "xhs.totalFollowing"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.isXHSPlatform) ? _c('v-col', {
    attrs: {
      "md": "6",
      "xs": "12"
    }
  }, [_c('v-text-field', {
    attrs: {
      "type": "number",
      "solo": "",
      "placeholder": "Enter Total Likes/Favourites"
    },
    model: {
      value: (_vm.xhs.totalLikesFavourites),
      callback: function($$v) {
        _vm.$set(_vm.xhs, "totalLikesFavourites", $$v)
      },
      expression: "xhs.totalLikesFavourites"
    }
  })], 1) : _vm._e()], 1) : _vm._e()], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    on: {
      "click": function($event) {
        return _vm.close()
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('v-btn', {
    staticClass: "secondary",
    on: {
      "click": function($event) {
        return _vm.createUser()
      }
    }
  }, [_vm._v("Save changes")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0eb9dee5"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/User/CreateUserModal.vue
// module id = 2002
// module chunks = 0